module.exports = __webpack_public_path__ + "assets/images/logo-24E7Oac.png";